import React, { useState } from "react";
import MainModel from "../../components/Models";
import { CustomInput } from "../../components/Inputs";
import { AlignContent } from "../../components/Cards";
import { useSelector } from "react-redux";
import { showFormErrors } from "../../utils/commonFunctions";
import { ReactComponent as EditIcon } from "../../assets/images/svg/pencil.svg";
import {
  createOrgAction, getUserOrgAction
} from "../../redux/Slices/organizationSlice";

export default function OrganizationForm({ isAddOrg, setIsAddOrg, dispatch }) {
  let user = useSelector((state) => state.org.data);
  const userState = useSelector((state) => state.user);
  const [data, setData] = useState({
    name: "", description: ""
  });

  const addOrg = () => {
    if (!data.name || !data.description || !data.description.trim() || !data.name.trim()) {
      setData({
        ...data,
        formErrors: !data.name || !data.name.trim() ? { name: "Please enter name" } : { description: "Please enter description" },
      });
    } else {
      // Get country from user state
      const country = userState.country_name || userState.data?.country_name || "India";
      
      // Log country value for debugging
      console.log("Country from user state:", userState.country_name);
      console.log("Country from user data:", userState.data?.country_name);
      console.log("Final country value:", country);
      
      const updatedData = { 
        name: data.name.trim(), 
        description: data.description.trim(),
        country: country // Add country to the data
      };
      
      // Log the data being sent
      console.log("Creating organization with data:", updatedData);
      
      dispatch(
        createOrgAction({
          data: updatedData,
          next: () => {
            dispatch(getUserOrgAction());
            setData({ name: '', description: '' });
            setIsAddOrg(false);
          }
        })
      );
    }
  };

  return (
    <MainModel
      title="Add New Organization"
      subTitle="Enter the Organization details"
      setVisible={setIsAddOrg}
      visible={isAddOrg}
      onSave={addOrg}
      saveLabel={'Submit'}
      onCancel={() => {
        setData({ name: '', description: '' });
      }}
    >
      <AlignContent extraClass="mb-3" >
        <CustomInput
          label="Name"
          value={data?.name}
          onChange={({ value }) => {
            setData({ ...data, name: value, formErrors: {} })
          }
          }
          col="col"
          name="name"
          data={data}
          extraClass="border-round bg-gray-100"
        />
      </AlignContent>
      <AlignContent extraClass="mb-3" >  <CustomInput
        label="Description"
        value={data?.description}
        onChange={({ value }) => {
          setData({ ...data, description: value, formErrors: {} })
        }
        }
        col="col"
        name="description"
        data={data}
        extraClass="border-round bg-gray-100"
      /></AlignContent>
    </MainModel>
  );
}
